import { ApolloLink } from "@apollo/client";
export default function createRuntimePermissionsCheckLink() {
    return new ApolloLink(function runtimePermissionsCheckLink(operation, forward) {
        return forward(operation);
    });
}

//# sourceMappingURL=createRuntimePermissionsCheckLink.js.map